<template>
  <!-- 装货作业单--装货明细-->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button v-if="canEdit && !intoStoreage" class="glo_btnItems" @click="fetchWaybill"
          >取出运单</el-button
        >
        <el-button v-if="canEdit && intoStoreage" class="glo_btnItems" @click="addOneWaybill"
          >取出运单</el-button
        >
        <el-button v-if="canEdit" class="glo_btnItems" @click="removeWaybill"
          >移除</el-button
        >
        <!-- <el-button class="glo_btnItems" @click="printEvent"
          >打印货物装货清单</el-button
        > -->
      </div>
    </div>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :maxHeight="300"
      :tableData="tableData_1"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
    >
      <template v-if="canEdit" #isReturnOrder="{ row }">
        <el-checkbox
          v-model="row.isReturnOrder"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
      </template>
      <template v-if="canEdit" #stockTypeShow="{ row }">
        <el-select
          v-model="row.stockType"
          @change="changeStockType(row)"
        >
          <el-option
            v-for="stockType in stockTypes"
            :key="stockType.stockType"
            :label="stockType.stockTypeShow"
            :value="stockType.stockType"
          ></el-option>
        </el-select>
      </template>
      <template v-if="canEdit" #cargoareaName="{ row }">
        <el-select
          v-model="row.storageAreaId"
          @change="changeRow(row)"
        >
          <el-option
            v-for="area in storeAreas"
            :key="area.id"
            :label="area.cargoareaName"
            :value="area.id"
          ></el-option>
        </el-select>
      </template>
      <template v-if="canEdit" #transportPlanShow="{ row }">
        <el-select
          v-model="row.transportPlan"
          @change="changeRow(row)"
        >
          <el-option
            v-for="plan in transportPlans"
            :key="plan.planValue"
            :label="plan.planName"
            :value="plan.planValue"
          ></el-option>
        </el-select>
      </template>
      <template v-if="canEdit" #remarks="{ row }">
        <el-input v-model="row.remarks" @change="changeRow(row)"></el-input>
      </template>
    </mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <myDialog
      diaWidth="1200px"
      dialogTitle="取出运单"
      :isShowDialog="showFetchWaybill"
      :showConfirm="true"
      @handleCloseDia="showFetchWaybill = false"
      @diaCancelBtn="showFetchWaybill = false"
      @diaConfirmBtn="handleCOnfirmWaybill"
    >
      <fetch-waybill :data="waybills" :dispatchId="dispatchId" ref="waybillSelector" v-if="showFetchWaybill"></fetch-waybill>
    </myDialog>
    <!-- 单票添加运单 -->
    <my-dialog
      diaWidth="400px"
      dialogTitle="取出运单"
      :isShowDialog="showFetchOneWaybill"
      :showConfirm="true"
      @handleCloseDia="showFetchOneWaybill = false"
      @diaCancelBtn="showFetchOneWaybill = false"
      @diaConfirmBtn="handleCOnfirmOneWaybill"
    >
      <el-form
        :model="fetchOneWaybill"
        label-width="60px"
        label-position="right"
      >
        <el-form-item label="运单号" prop="waybillNumber">
          <el-input v-model="fetchOneWaybill.waybillNumber"></el-input>
        </el-form-item>
      </el-form>
    </my-dialog>

    <!-- *********************************打印 start ********************************* -->
    <!-- 选择打印模板 -->
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      modelTypeVal="调度配载模块"
      ref="myPrint"
      :dataSource="printDataSource"
    ></my-print>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
import FetchWaybill from "./FetchWaybill.vue";
import MyPrint from "@/components/print/MyPrint.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    sorttable,
    paging,
    mytable,
    myDialog,
    FetchWaybill,
    MyPrint
  },
  props: {
    loadOrderId: {},
    dispatchId: {},
    canEdit: {
      type: Boolean,
      default: false,
    },
    op:{}
  },
  data() {
    let reportFiledsNumber = 'admin_dispatch_unload_detail_bill_list_v5';
    if(this.op === 'intoStoreage'){
      reportFiledsNumber = 'admin_dispatch_unload_waybill_list'
    }
    
    // else if(!this.loadOrderId){
    //   reportFiledsNumber = 'admin_dispatch_disload_bill_list_4_edit_v5'
    // }
    return {
      pageGroupName: "PickupDispatchCar324", //  页面标识
      reportFiledsNumber, // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 打印插件 每个页面不一样的
      idarrs: [],
      classNameArr: [
        {
          name: "发车单",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
      // 表格右边操作按钮
      btnsList: [],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      Operatewidth: "220px", //操作列的列宽
      tableData_1: [],
      //
      showFetchOneWaybill: false,
      fetchOneWaybill: {
        waybillNumber: "",
      },
      showFetchWaybill: false,
      waybills: [],
      transportPlans: [],
      stockTypes:[],
      storeAreas:[]
    };
  },
  mounted() {
    this.getTransportPlans();
    this.getStockTypes()
    this.getStoreAreas()
    this.getData({
      loadOrderId: this.loadOrderId,
      dispatchId:this.dispatchId,
      transportPlan:this.intoStoreage ? 'ru_cang:transport_plan':''
    }).then((res) => {
      if(this.intoStoreage){
        this.tableData.map(item=>item.operationType = 'ADD')
      }
      this.tableData_1 = this.tableData;
    });
  },
  computed: {
    editable() {
      return false;
    },
    feeCheckIn() {
      return false;
    },
    intoStoreage() {
      return this.op === "intoStoreage";
    }
  },
  watch: {
    loadOrderId: {
      handler(val) {
        if (val) {
          this.getData({
            loadOrderId: val,
          });
        }
      },
    },
    dispatchId: {
      handler(val) {},
    },
  },
  methods: {
    async getStockTypes(){
      const res = await this.$API.runList({
        number: "admin_stock_type_list_v5",
      });
      this.stockTypes = res;
    },
    async getStoreAreas(){
      const res = await this.$API.runList({
        number: "admin_store_area_list_v5",
      });
      this.storeAreas = res;
    },
    async getTransportPlans() {
      const res = await this.$API.runList({
        number: "unload_transport_plan_list",
      });
      this.transportPlans = res;
    },
    changeStockType(row){
      if(row.operationType !=='ADD'){
        row.operationType = 'UPDATE'
      }
    },
    changeRow(row) {
      if(row.operationType !=='ADD'){
        row.operationType = 'UPDATE'
      }
    },
    // 取出库存
    fetchWaybill() {
      this.waybills = this.tableData_1.map(item=>item.waybillSplitId)
      this.showFetchWaybill = true;
    },
    handleCOnfirmWaybill() {
      this.showFetchWaybill = false;
      const rows = this.$refs.waybillSelector.getRows();
      const ids = this.tableData.map((item) => item.waybillSplitId);
      rows.map((item) => {
        if (!ids.includes(item.waybillSplitId)) {
          this.tableData.push({
            ...item,
            waybillRemarks: item.remarks,
            remarks: "",
            documentStatus: "bill_pick_command_v3:document_status",
            operationType: "ADD",
            stockType:this.stockTypes[0] && this.stockTypes[0].stockType,
            // 默认选中第一行方案
            transportPlan:
              this.transportPlans[0] && this.transportPlans[0].planValue,
          });
        }
      });
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
    },
    // 单票添加运单
    addOneWaybill() {
      this.showFetchOneWaybill = true;
    },
    async handleCOnfirmOneWaybill() {
      const res = await this.$API.runList({
        number: "admin_dispatch_unload_waybill_list",
        dispatchId:this.dispatchId,
        transportPlanNeq:'ru_cang:transport_plan',
        waybillNumber: this.fetchOneWaybill.waybillNumber
      });
      if (!res || res.length == 0) {
        this.$message.error("该运单不在本车次内");
        return;
      }
      const ids = this.tableData.map((item) => item.waybillSplitId);
      res.map((item) => {
        if (!ids.includes(item.waybillSplitId)) {
          this.tableData.push({
            ...item,
            waybillRemarks: item.remarks,
            remarks: "",
            operationType: "ADD",
            stockType:this.stockTypes[0] && this.stockTypes[0].stockType,
            // 默认选中第一行方案
            transportPlan:
              this.transportPlans[0] && this.transportPlans[0].planValue,
          });
        }
      });
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.showFetchOneWaybill = false;
      this.fetchOneWaybill.waybillNumber = "";
    },
    // 移除
    removeWaybill() {
      this.selectTableData.map((item) => {
        if (item.operationType === "ADD") {
          item.operationType = "REMOVE";
        } else {
          item.operationType = "DEL";
        }
      });
      this.$refs.mytable.clearSelection();
      this.tableData = this.tableData.filter(
        (item) => item.operationType !== "REMOVE"
      );
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
    },
    printList() {},
    getRows() {
      return this.tableData.map((item, index) => {
        return {
          taskId: item.taskId,
          documentStatus: "bill_tms_waybill_split_v3:document_status",
          documentNumber: item.documentNumber,
          transportPlan: item.transportPlan,
          remarks: item.remarks,
          sort: index,
          isReturnOrder: item.isReturnOrder,
          stockType: item.stockType,
          storageAreaId: item.storageAreaId,
          operationType: item.operationType || "UNCHANGED",
        };
      });
    },
    // *************************打印模板 start *************************
    printDataSource(rows) {
      return Promise.resolve(rows)
    }

    // // 打印相关的
    // handleCloseDia_print() {
    //   this.isShowDialog_print = false;
    // },
    // // 打印预览确定
    // diaConfirmBtn_print() {
    //   this.isShowDialog_print = false;
    // },
    // 打印相关的
    // *************************打印模板 end *************************
  },
};
</script>

<style lang="less" scoped>
</style>